import { render, staticRenderFns } from "./TableCustomField.vue?vue&type=template&id=b3cbd90c"
import script from "./TableCustomField.vue?vue&type=script&lang=js"
export * from "./TableCustomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports